
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.746","height":"26.746","viewBox":"0 0 26.746 26.746"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('circle',{attrs:{"cx":"13.373","cy":"13.373","fill":"#18db38","r":"13.373"}}),_c('path',{staticClass:"b",attrs:{"d":"M12.311 17.83a1.291 1.291 0 01-1.7 0l-2.97-2.971a1.291 1.291 0 010-1.7 1.291 1.291 0 011.7 0l2.972 2.972a1.284 1.284 0 01-.002 1.699z"}}),_c('path',{staticClass:"b",attrs:{"d":"M11.037 17.831a1.291 1.291 0 010-1.7l7.217-7.217a1.291 1.291 0 011.7 0 1.291 1.291 0 010 1.7l-7.217 7.217a1.291 1.291 0 01-1.7 0z"}})])])
          )
        }
      }
    